import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.format()
    this.autofillTimeout = window.setTimeout(() => this.format(), 100)
  }

  disconnect() {
    if (this.autofillTimeout) {
      window.clearTimeout(this.autofillTimeout)
    }
  }

  format() {
    const digits = this.element.value.replace(/\D/g, "").slice(0, 10)

    if (digits.length <= 3) {
      this.element.value = digits
      return
    }

    if (digits.length <= 6) {
      this.element.value = `${digits.slice(0, 3)}-${digits.slice(3)}`
      return
    }

    this.element.value = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
  }
}
